<template>
    <ul>
        <li v-for="item in lists" :key='item.id'>
            <div class="content">
            <div class="img">
                <img
                width="300"
                height="229"
                :src="item.image"
                class="cover-image wp-post-image"
                >
            </div>
            <div class="discription">
                <h6>{{item.title}}</h6>
               {{item.introduction}}
            </div>
            <a
                href="#/Qualification?id=15"
                class="readmore"
            >阅读更多</a>
            </div>
        </li>

    </ul>
</template>
<script>
import ajax from '../ajax'
export default {
    data() {
        return {
          lists:[]
        }
    },
    props:{
        pageNo:{
            default:0,
        },
        pageSize:{
            default:9
        }
    },
    mounted() {
        this.getdata()
    },
    watch: {
        pageNo(value){
            this.getdata()
        }
    },
    methods: {
        getdata(){
           ajax.getPagelatest({pageNo:this.pageNo,pageSize:this.pageSize}).then(res=>{
               this.lists = res.data.data;
               this.$emit('totalInit',res.data.total)
           })
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/template/reports.vue